import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./otp.css";
import { useNavigate } from "react-router-dom";
import { verfiyOtp } from "../../../services/AuthService";
import useReducerHook from "../../../hooks/useReducerHook";
import useNavigateMenuId from "../../../hooks/useMenuId";
import useFindMenuID from "../../../hooks/useFindSlug";
import { toast } from "react-toastify";

const Otp = () => {
  const { pageMenus } = useReducerHook();

  const { navigatePageId } = useNavigateMenuId();
let loginPage = useFindMenuID(pageMenus?.menuData, "login");
  const checkOtp = async (value) => {
    const email = localStorage.getItem("email");
    try {
      const payload = {
        otp_code: value,
        email: email,
      };
      const response = await verfiyOtp(payload);
      if (response.status_code === 200) {
        toast.success("Otp Verified!Please Login")
        navigatePageId(loginPage)
        localStorage.removeItem("email");
      } else {
        toast.error("Invalid Otp");
      }
    } catch (error) {}
  };
  const formik = useFormik({
    initialValues: {
      otp: ["", "", "", "", "", ""],
    },
    validationSchema: Yup.object({
      otp: Yup.array()
        .of(Yup.string().required())
        .test("len", "OTP must be exactly 6 digits", (otp) => {
          return otp ? otp.join("").length === 6 : false;
        }),
    }),
    onSubmit: (values) => {
      checkOtp(String(values.otp.join("")));
    },
  });

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (value === "" || /^\d$/.test(value)) {
      formik.setFieldValue(`otp[${index}]`, value);
      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !formik.values.otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit} className="otp-verify-form">
        <div className="otp-inputs">
          {formik.values.otp.map((_, index) => (
            <input
              key={index}
              id={`otp-${index}`}
              name={`otp[${index}]`}
              type="text"
              maxLength={1}
              className={`otp-input ${
                formik.touched.otp && !formik.values.otp[index]
                  ? "error-border"
                  : ""
              }`}
              value={formik.values.otp[index]}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onBlur={() => formik.setFieldTouched(`otp[${index}]`)}
              autoComplete="off"
            />
          ))}
        </div>
        <button
          type="submit"
          disabled={!formik.isValid || formik.isSubmitting || !formik.dirty}
          sx={{ mt: 2 }}
          className={`p-3 mt-5 otp-btn ${
            !formik.isValid || formik.isSubmitting || !formik.dirty
              ? "disabled"
              : ""
          }`}
          style={{
            backgroundColor:
              !formik.isValid || formik.isSubmitting || !formik.dirty
                ? "#e0e0e0"
                : "",
            cursor:
              !formik.isValid || formik.isSubmitting || !formik.dirty
                ? "not-allowed"
                : "pointer",
          }}
        >
          Verify OTP
        </button>
      </form>
    </>
  );
};

export default Otp;
